module.exports = __webpack_public_path__ + "static/media/home_background2.e2cd24ca.svg";